import * as Yup from 'yup'
const schema=Yup.object().shape({
    isEntity:Yup.boolean().required()
})
export default schema